import { createClient, type SupabaseClient } from '@supabase/supabase-js'

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined

let supabase: SupabaseClient | null = null

if (supabaseUrl && supabaseAnonKey) {
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
  })
}

export { supabase }

export function isSupabaseConfigured(): boolean {
  return Boolean(supabase)
}

export const supabaseAuthTokenKey = (() => {
  if (!supabaseUrl) return null
  try {
    const url = new URL(supabaseUrl)
    const projectRef = url.host.split('.')[0]
    return projectRef ? `sb-${projectRef}-auth-token` : null
  } catch (error) {
    console.warn('Supabase URL parse error:', error)
    return null
  }
})()
